import dateFormat from '@/common/format/date-format.js';
export const fifteenMin = 15 * 60 * 1000;
export const oneDay = 24 * 60 * 60 * 1000;
export const bookDayLength = 30;
export const getTodayStartTime = () => {
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    return startOfDay.getTime();
};
export const TIME_BEFORE_TYPE_MAP = {
    // showing config option
    0: 0,
    100: 30 * 60 * 1000,
    1: 1 * 60 * 60 * 1000,
    2: 2 * 60 * 60 * 1000,
    3: 3 * 60 * 60 * 1000,
    6: 6 * 60 * 60 * 1000,
    24: 24 * 60 * 60 * 1000,
    48: 48 * 60 * 60 * 1000,
    101: -1 // tomorrow
};

export const weekKey = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function padStart(num, count) {
    return (num + '').padStart(count, '0');
}
//8:09 AM
export function getTime_hmmA(t, needSpace) {
    const time = new Date(t);
    let hours = time.getHours();
    const minutes = time.getMinutes();
    const isAM = hours < 12 ? 'AM' : 'PM';
    hours =
        hours < 12
            ? hours === 0
                ? hours + 12
                : hours
            : hours === 12
                ? hours
                : hours - 12;
    return `${hours}:${padStart(minutes, 2)}${needSpace ? ' ' : ''}${isAM}`;
}

export const getStartList = day => {
    if (!day) {
        return []; 
    }
    return day.available
        .map(availableItem => {
            let ret = [];
            let [start, times15] = availableItem;
            for (let idx = 0; idx < times15; idx++) {
                ret.push({
                    name: getTime_hmmA(start),
                    id: start,
                    right: times15 - idx
                });
                start += fifteenMin;
            }
            return ret;
        })
        .flat();
};

export const getEndList = timeRange => {
    const { maxLength, start, right } = timeRange;
    const validMax = Math.min(right, maxLength);
    let ret = [];
    for (let i = 1; i <= validMax; i++) {
        const text = getTime_hmmA(start + i * fifteenMin);
        ret.push({ id: i, name: text });
    }
    return ret;
};

function cut15min(start, end) {
    const start15 = Math.ceil(start / fifteenMin);
    const end15 = Math.floor(end / fifteenMin);
    if (end15 <= start15) {
        return;
    }
    return [start15 * fifteenMin, end15 - start15];
}

export function calculateDays({ $t, bookedTimeList, beforeShowingType }) {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    bookedTimeList = [...bookedTimeList, { startTime: +today, endTime: +now }];
    const timeBefore = TIME_BEFORE_TYPE_MAP[beforeShowingType];

    if (timeBefore >= 0) {
        bookedTimeList.push({ startTime: +today, endTime: +now + timeBefore });
    } else {
        // tomorrow
        bookedTimeList.push({ startTime: +today, endTime: +today + oneDay });
    }
    bookedTimeList = bookedTimeList.sort((v1, v2) => {
        return v2.startTime - v1.startTime;
    });
    const days = [];
    let bookedTime = bookedTimeList.pop();
    for (let i = 0; i < bookDayLength; i++) {
        const dayStart = +today + i * oneDay;
        const dayEnd = dayStart + oneDay;

        const date = new Date(dayStart);
        let availableStart = dayStart;
        let week = $t(`common:${weekKey[date.getDay()]}`);
        // if (i == 0) {
        //     week = $t('common:Today');
        // }
        // if (i == 1) {
        //     week = $t('common:Tomorrow');
        // }
        if (date.getMonth() == 0 && date.getDate() == 1) {
            week = date.getFullYear();
        }
        const dayObj = {
            dayStart,
            week,
            day: date.getDate(),
            month: dateFormat('MMM', date),
            available: []
        };
        days.push(dayObj);
        while (bookedTime && bookedTime.startTime < dayEnd) {
            const { startTime, endTime } = bookedTime;
            if (endTime <= availableStart) {
                bookedTime = bookedTimeList.pop();
                continue;
            }
            if (startTime > availableStart) {
                const availableItem = cut15min(availableStart, startTime);
                availableItem && dayObj.available.push(availableItem);
            }
            availableStart = endTime;
            if (endTime < dayEnd) {
                bookedTime = bookedTimeList.pop();
                continue;
            }
            break;
        }
        if (availableStart < dayEnd) {
            const availableItem = cut15min(availableStart, dayEnd);
            availableItem && dayObj.available.push(availableItem);
        }
    }
    return days;
}
